import * as React from 'react';
import type { ConfirmLabels } from '../../organisms/confirm-form';
// import { ConfirmForm } from '../../organisms/confirm-form';
import type { LoginLabels } from '../../organisms/login-form';
import { LoginForm } from '../../organisms/login-form';
import { ResetPassword } from '../reset-password';
import { LoginStepEnum, useLogin } from './useLogin';
import type { BrandLogo } from '@components/molecules/brand-header';
import { ChangeTemporaryPasswordForm } from '@components/organisms/change-temp-password-form';
import type { ChangeTemporaryPasswordFormLabels } from '@components/organisms/change-temp-password-form';
import type { SelectEmailFormLabels } from '@components/organisms/choose-email-form';
import type { ResetPasswordLabels } from '@components/organisms/reset-password-form';

type Props = {
	labels: {
		login: LoginLabels;
		resetPassword: ResetPasswordLabels;
		chooseEmail: SelectEmailFormLabels;
		changePassword: ChangeTemporaryPasswordFormLabels;
		confirm: ConfirmLabels;
	};
	logo?: BrandLogo;
	tosLink?: string;
	onSuccess: (data: any) => Promise<void> | void;
	handleNavigateToLink?: () => void;
	onSSOSuccess: () => void | Promise<void>;
};

export const Login: React.FC<Props> = ({ labels, logo, tosLink, onSuccess, handleNavigateToLink, onSSOSuccess }) => {
	const { step, handleLogin, changeStep, handleChangePassword, errorCode } = useLogin({
		onSuccess,
	});

	const error: string | undefined = labels.login.errors?.[errorCode!] ?? undefined;

	const CurrentStep: React.ReactNode = React.useMemo(() => {
		const goBackToLogin = () => changeStep(LoginStepEnum.LOGIN);

		switch (step) {
			case 'login':
				return (
					<LoginForm
						tosLink={tosLink}
						labels={labels.login}
						logo={logo}
						onSubmit={handleLogin}
						handleNavigateToForgotPassword={() => changeStep(LoginStepEnum.RESET_PASSWORD)}
						handleNavigateToLink={handleNavigateToLink}
						externalError={error}
						onSSOSuccess={onSSOSuccess}
					/>
				);
			// case 'confirm':
			// 	return <ConfirmForm labels={labels.confirm} onSubmit={confirmCode} onRequestNewCode={handleResendCode} />;
			case 'change-temp-password':
				return <ChangeTemporaryPasswordForm labels={labels.changePassword} onSubmit={handleChangePassword} />;
			case 'reset-password':
				return (
					<ResetPassword
						labels={{ chooseEmail: labels.chooseEmail, resetPassword: labels.resetPassword }}
						onPasswordReset={goBackToLogin}
						goBackToLogin={goBackToLogin}
					/>
				);
			default:
				return null;
		}
	}, [step, logo, handleLogin, handleNavigateToLink, handleChangePassword, changeStep, onSSOSuccess]);

	return <div className="flex w-full flex-col justify-center">{CurrentStep}</div>;
};
